import $ from 'jquery';
import select2 from 'select2';
select2($);
window.$ = window.jQuery = $;
export function renderselect2() {
    let isCheck = false;
    const SEARCH_SUBMIT_ACTIVE_LABEL = 'この条件で検索する';
    const SEARCH_SUBMIT_DISABLED_LABEL = '条件を指定してください';
    const btnSearchSubmitEl    = document.getElementById('jsBtnSearchSubmit'),
          filterResetEl        = document.getElementById('jsFilterReset'),
          filterEl             = document.getElementById('jsFilter'),
          filterResultEl       = document.getElementById('jsFilterResult'),
          filterSelectEl       = document.getElementById('genreB_id'),
          filterResultSelectEl = document.getElementById('genreS_id'),
          searchEl             = document.getElementById('jsSearch'),
          lecturerEl           = document.getElementById('lecturer'),
          params               = new URLSearchParams(window.location.search);

    function hasActiveSearchConditions() {
        const selectedGenreB = document.querySelector('input[name="genreB"]:checked');
        const selectedGenreS = document.querySelector('input[name="genreS"]:checked');
        const keyword = lecturerEl?.value?.trim() ?? '';
        const selectValues = ['#money_code', '#style', '#gender', '#pref_id', '#genreB_id', '#genreS_id']
            .some(selector => {
                const value = $(selector).val();
                if (Array.isArray(value)) {
                    return value.length > 0;
                }

                return value !== null && String(value).trim() !== '' && String(value) !== '-1';
            });

        return Boolean(selectedGenreB || selectedGenreS || keyword !== '' || selectValues);
    }

    function setSearchSubmitState(enabled) {
        if (!btnSearchSubmitEl || !searchEl) {
            return;
        }

        btnSearchSubmitEl.dataset.state = enabled ? '' : 'disable';
        btnSearchSubmitEl.textContent = enabled ? SEARCH_SUBMIT_ACTIVE_LABEL : SEARCH_SUBMIT_DISABLED_LABEL;
        searchEl.dataset.state = enabled ? '' : 'init';
    }

    function syncSearchSubmitState() {
        if (hasActiveSearchConditions() || isCheck) {
            setSearchSubmitState(true);
            return;
        }

        setSearchSubmitState(false);
    }

    function createRadioChild(data) {
        const liEl = window.createTag('li', { className: 'e-radio--highlight'});
        const inputEl = window.createTag('input', { type: 'radio', name: 'genreS', id: data.id, value: data.value});
        const labelEl = window.createTag('label', { htmlFor: data.id, textContent: data.text });
        liEl.appendChild(inputEl);
        liEl.appendChild(labelEl);
        filterResultEl.appendChild(liEl);
    }

    function createRadioItem(data) {
        const liEl = window.createTag('li', { className: 'e-radio--highlight'});
        const inputEl = window.createTag('input', { className: 'jsRadioFilter', type: 'radio', name: 'genreB', id: data.id, value: data.value});
        const labelEl = window.createTag('label', { htmlFor: data.id, textContent: data.text });
        liEl.appendChild(inputEl);
        liEl.appendChild(labelEl);
        filterEl?.appendChild(liEl);
        inputEl.addEventListener('change', () => {
            filterResultEl.innerHTML = '';
            setSearchSubmitState(true);
            if(data.childs) {
                data.childs.forEach(child => {
                    createRadioChild(child);
                });
            };
            isCheck = true;
        });
        const optionEl = new Option(data.text, data.id, false, false);
        $(filterSelectEl).append(optionEl).trigger('change');
    }
    async function loadJSON() {
        const res = await fetch('/ajax/genre/');
        const datas = await res.json();
        if(datas.length > 0) {
            datas.forEach(data => {
                createRadioItem(data);
            });
            $('.jsSelect2').each(function () {
                const $select = $(this);
                const defaultValue = $select.data('selected');
                $select.select2({
                    minimumResultsForSearch: Infinity,
                    width: '100%',
                    dropdownCssClass: '.e-select2__dropdown',
                    placeholder: {
                        id: '',
                        text: '選択してください',
                    }
                });
                $select.val('').trigger('change');
                if (defaultValue !== undefined && defaultValue !== "") {
                    $select.val(defaultValue).trigger('change');
                    setSearchSubmitState(true);
                }
            });
            $('.jsSelect2').on('select2:select', function (e) {
                const data = e.params.data;
                if(data.id === '-1') {
                    $(this).val('').trigger('change');
                }
                if($(this)[0].id === 'genreB_id') {
                    const dataItem = datas.find(obj => obj.id === parseInt(data.id));
                    if(dataItem.childs.length > 0) {
                        $(filterResultSelectEl).empty().append('<option value=""></option>').val(null).trigger('change');
                        dataItem.childs.forEach(data => {
                            const optionEl = new Option(data.text, data.id, false, false);
                            $(filterResultSelectEl).append(optionEl).trigger('change');
                            createRadioChild(data);
                        });
                    }
                }

                if(btnSearchSubmitEl) {
                    if(data.id != '' && data.id != -1) {
                        setSearchSubmitState(true);
                    }else {
                        syncSearchSubmitState();
                    }
                }
            });
            // if(params) {
                const genreB = params.get('genreB') || filterSelectEl?.dataset.selected;
                const genreS = params.get('genreS') || filterResultSelectEl?.dataset.selected;
                if(genreB) {
                    const inputEl = document.getElementById(genreB);
                    if(inputEl) {
                        inputEl.checked = true;
                        filterResultEl.innerHTML = '';
                        setSearchSubmitState(true);
                        datas.forEach(data => {
                            if(data.id === parseInt(inputEl.id)) {
                                if(data.childs) {
                                    data.childs.forEach(child => {
                                        createRadioChild(child);
                                    });
                                    const inputSEl = document.getElementById(genreS);
                                    if(inputSEl) {
                                        inputSEl.checked = true;
                                    }
                                }
                            }
                        });
                    }
                    if($('#genreB_id').length) {
                        $('#genreB_id').val(genreB).trigger('change');
                        const dataItem = datas.find(obj => obj.id === parseInt(genreB));
                        if(dataItem.childs.length > 0) {
                            $(filterResultSelectEl).empty().append('<option value=""></option>').val(null).trigger('change');
                            dataItem.childs.forEach(data => {
                                const optionEl = new Option(data.text, data.id, false, false);
                                $(filterResultSelectEl).append(optionEl).trigger('change');
                            });
                        }
                    }
                }
                if(genreS) {
                    $('#genreS_id').val(genreS).trigger('change');
                }
            // }
        }
    }

    loadJSON();

    if(filterResetEl) {
        filterResetEl.addEventListener('click', () => {
            const radioFilterEls = document.querySelectorAll('[name="genreB"], [name="genreS"]');
            radioFilterEls.forEach(radioFilterEl => {
                if (radioFilterEl.type === 'radio') {
                    radioFilterEl.checked = false;
                }
            });
            isCheck = false;
            filterResultEl.innerHTML = '';
            $(filterSelectEl).val('').trigger('change');
            $(filterResultSelectEl).empty().append('<option value=""></option>').val('').trigger('change');
            syncSearchSubmitState();
        });
    }

    $('.jsSelectSingle').each(function () {
        const $select = $(this);
        const defaultValue = $select.data('selected');
        $select.select2({
            dropdownCssClass: 'select2-dropdown--custom',
            minimumResultsForSearch: Infinity,
        });
        if (defaultValue !== undefined && defaultValue !== "") {
            $select.val(defaultValue).trigger('change');
        }
    });

    if(lecturerEl && btnSearchSubmitEl) {
        let isKeywordComposing = false;

        const syncKeywordState = () => {
            if ((lecturerEl.value || '').trim() !== '') {
                setSearchSubmitState(true);
            } else {
                syncSearchSubmitState();
            }
        };

        lecturerEl.addEventListener('compositionstart', () => {
            isKeywordComposing = true;
        });

        lecturerEl.addEventListener('compositionend', () => {
            isKeywordComposing = false;
            syncKeywordState();
        });

        lecturerEl.addEventListener('input', () => {
            if (isKeywordComposing) {
                return;
            }

            syncKeywordState();
        });

        lecturerEl.addEventListener('change', syncKeywordState);
    }
}
